
import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import AbstractForceMuteRemoteParticipantsVideoDialog, { _mapStateToProps }
    from '../AbstractForceMuteRemoteParticipantsVideoDialog';

/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before disabling a remote participants camera.
 *
 * @augments Component
 */
class MuteRemoteParticipantsVideoDialog extends AbstractForceMuteRemoteParticipantsVideoDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const audios = this.props._lockVideo;
        const { participantID } = this.props;

        return (
            <Dialog
                okKey = { audios[`${participantID}`] ? 'dialog.unforceMuteParticipantsVideoButton'
                    : 'dialog.forceMuteParticipantsVideoButton' }
                onSubmit = { this._onSubmit }
                titleKey = { audios[`${participantID}`] ? 'dialog.unforceMuteParticipantsVideoTitle'
                    : 'dialog.forceMuteParticipantsVideoTitle' }
                width = 'small'>
                <div>
                    {audios[`${participantID}`] ? this.props.t('dialog.unforceMuteParticipantsVideoBody')
                        : this.props.t('dialog.forceMuteParticipantsVideoBody') }
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(_mapStateToProps)(MuteRemoteParticipantsVideoDialog));
